var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "users" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 44, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "姓名" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 50, clearable: true },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "证件号码", "label-width": 75 } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { maxlength: 18, clearable: true },
                            model: {
                              value: _vm.search.idCard,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "idCard", $$v)
                              },
                              expression: "search.idCard",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "性别" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: {
                                width: "100%",
                                "min-width": "75px",
                              },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.gender,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "gender", $$v)
                                },
                                expression: "search.gender",
                              },
                            },
                            _vm._l(_vm.enums.genderList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.code,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.code },
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "学校名称",
                            prop: "schoolId",
                            "label-width": 80,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "学校名称",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: { change: _vm.changeSchool },
                              model: {
                                value: _vm.search.schoolId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "schoolId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.schoolId",
                              },
                            },
                            _vm._l(_vm.schoolList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleShoolChange(item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "年级", prop: "gradeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "年级",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: { change: _vm.changeGrade },
                              model: {
                                value: _vm.search.gradeId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "gradeId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.gradeId",
                              },
                            },
                            _vm._l(_vm.gradeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleGradeChange(item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "班级", prop: "classesId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "班级",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.classesId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "classesId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.classesId",
                              },
                            },
                            _vm._l(_vm.classesList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleClassChange(item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("\n                "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "5px",
                display: "flex",
                width: "100%",
              },
              attrs: { slot: "extra" },
              slot: "extra",
            },
            [
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", icon: "md-add", type: "primary" },
                  on: { click: _vm.handleCreate },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "姓名",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "gender",
              label: "性别",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(
                        row.gender === 1 ? "男" : row.gender === 2 ? "女" : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "birthday",
              label: "出生日期",
              "min-width": "95",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "idCardType",
              label: "证件类型",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.enums.idCardTypes.filter(
                          (u) => u.value === row.idCardType
                        )[0].label
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "idCard",
              label: "证件号码",
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "schoolName",
              label: "学校",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "gradeName",
              label: "年级",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "classesName",
              label: "班级",
              "min-width": "140",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "source",
              label: "数据来源",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          row.source === 1
                            ? "pc系统"
                            : row.source === 2
                            ? "小程序系统"
                            : row.source === 3
                            ? "导入"
                            : "自主填报"
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "updateTime",
              label: "最后操作时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditStatus(row, null, row.status)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            width: "60%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("StudentsEdit", {
            ref: "edit",
            style: { "max-height": _vm.maxHeight, "overflow-y": "auto" },
            on: { "on-submit": _vm.handleSubmit },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入学生",
            visible: _vm.importWindow,
            width: "400px",
            "custom-class": "my-dialog",
            "destroy-on-close": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importWindow = $event
            },
          },
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                limit: 1,
                drag: "",
                multiple: "",
                "auto-upload": false,
                "on-change": _vm.handleChange,
                "on-remove": _vm.handleRemove,
                "file-list": _vm.fileList,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")]),
              ]),
            ]
          ),
          _c("div", [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.template()
                  },
                },
              },
              [_vm._v("文件模版")]
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancle } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleUpload } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }